var _a;
import * as flavr_common from "flavr-common";
import * as flavr_math from "flavr-math";
import { ModelScriptBase } from "./ModelScriptBase";
import { ScriptModel } from "./ScriptModel";
import { ScriptTime } from "../script/ScriptTime";
import { ScriptBase } from "../script/ScriptBase";
import { ScriptRaycaster } from "../imports/ScriptRaycaster";
import { ScriptInput } from "../imports/ScriptInput";
import { ScriptMoveGestureManager } from "../imports/ScriptMoveGestureManager";
import { ScriptMediaManager } from "../imports/ScriptMediaManager";
import { ScriptSession } from "../imports/ScriptSession";
import { ScriptPlayer } from "../imports/ScriptPlayer";
import { LayouterParameters, UTILITY_ROOM_UID } from "flavr-common";
import { ScriptHistoryService } from "../services/ScriptHistoryService";
import { ScriptCamera } from "../imports/ScriptCamera";
import { MovementMode } from "@messages/movement/MovementMessages";
import { ScriptNetworkInfo } from "../imports/ScriptNetworkInfo";
import { ScriptController } from "../imports/ScriptController";
import { HistoryEventType } from "@messages/scripting/ScriptMessages";
import { ScriptXR } from "../imports/ScriptXR";
import { ScriptFetch } from "../imports/ScriptFetch";
import { ScriptRoom } from "../imports/ScriptRoom";
import { ScriptTextMetrics } from "../imports/ScriptTextMetrics";
import { ScriptFileManager } from "../imports/ScriptFile";
import { ScriptToast } from "../imports/ScriptToast";
import { ScriptRosBagPlayerControls } from "../imports/ScriptRosBagPlayerControls";
import { ScriptTeleporterManager } from "../imports/ScriptTeleporterManager";
import { ScriptUIBus } from "../imports/ScriptUIBus";
import { ScriptToolViewerBelt } from "../imports/ScriptToolViewerBelt";
import { ScriptReflectionProbeManager } from "../imports/ScriptReflectionProbeManager";
import { ScriptSTT } from "../imports/ScriptSTT";
import { ScriptDebug } from "@modules/scripting/imports/ScriptDebug";
import { ScriptTraining } from "@modules/scripting/imports/ScriptTraining";
import { ScriptAnimation } from "@modules/scripting/imports/ScriptAnimation";
const UTILITY_ROOM = new ScriptModel();
UTILITY_ROOM.modelUID = UTILITY_ROOM_UID;
export const MODEL_SCRIPT_IMPORTS = {
    ModelBase: ModelScriptBase,
    ModelScriptBase,
    Model: ScriptModel,
    // class imports
    CameraService: ScriptCamera,
    Camera: ScriptCamera,
    Controller: ScriptController,
    Fetch: ScriptFetch,
    FileManager: ScriptFileManager,
    HistoryService: ScriptHistoryService,
    HistoryEventType,
    Time: ScriptTime,
    Input: ScriptInput,
    MoveGestureManager: ScriptMoveGestureManager,
    ReflectionProbeManager: ScriptReflectionProbeManager,
    ToolViewerBelt: ScriptToolViewerBelt,
    STT: ScriptSTT,
    MediaManager: ScriptMediaManager,
    NetworkInfo: ScriptNetworkInfo,
    ObjectAnimation: ScriptAnimation,
    Player: ScriptPlayer,
    Raycaster: ScriptRaycaster,
    Room: ScriptRoom,
    SessionPermissions: ScriptSession,
    Session: ScriptSession,
    TeleporterManager: ScriptTeleporterManager,
    // collision with dom TextMetrics
    ScriptTextMetrics: ScriptTextMetrics,
    Toast: ScriptToast,
    Training: ScriptTraining,
    UIBus: ScriptUIBus,
    XR: ScriptXR,
    Debug: ScriptDebug,
    Date,
    String,
    // types
    flavr_common,
    flavr_math,
    Set,
    Map,
    Array,
    UTILITY_ROOM,
    MovementMode,
    WorldLayouterParameters: (_a = class WorldLayouterParameters extends LayouterParameters {
            constructor(worldId) {
                super();
                this.worldId = worldId;
            }
        },
        _a.layouterId = "world",
        _a),
    RosBagPlayerControls: ScriptRosBagPlayerControls
};
for (const [name, func] of Object.entries(flavr_math)) {
    if (MODEL_SCRIPT_IMPORTS[name] !== undefined)
        continue;
    MODEL_SCRIPT_IMPORTS[name] = func;
}
for (const [name, func] of Object.entries(flavr_common)) {
    if (MODEL_SCRIPT_IMPORTS[name] !== undefined)
        continue;
    MODEL_SCRIPT_IMPORTS[name] = func;
}
export const PARAMETER_SCRIPT_IMPORTS = {
    ScriptBase
};
export const FUNCTION_SCRIPT_IMPORTS = {
    flavr_common,
    flavr_math
};
